import { render, staticRenderFns } from "./EduPositionSingleCell.vue?vue&type=template&id=2f36c7a5&"
import script from "./EduPositionSingleCell.vue?vue&type=script&lang=ts&"
export * from "./EduPositionSingleCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports